import { ShortcutCard } from 'ui/components';

export const ShortcutCardFeature: React.FC<Umbraco.ShortcutCard> = ({ content }) => {
	return <ShortcutCard {...content?.properties} />;
};
